<div class="flex flex-col h-full">
	<div class="mb-4 flex justify-between">
		<div>
			<h4>Import details from Teranet search results</h4>
			<p>Please select the instrument you would like to requisition</p>
		</div>

		<app-icon
			[icon]="ICON.CLOSE"
			class="cursor-pointer"
			(click)="closeModal()"
		></app-icon>
	</div>
	<div class="flex mb-4">
		<atomic-button-group
			type="tab"
			[options]="tabs"
			[(ngModel)]="selectedTab"
		></atomic-button-group>
	</div>

	<div class="h-full min-h-0 flex-1">
		<app-teranet-writs-requisition
			class="h-full"
			*ngIf="selectedTab === 2"
		></app-teranet-writs-requisition>

		<app-teranet-instruments-requisition
			class="h-full"
			*ngIf="selectedTab === 1"
		></app-teranet-instruments-requisition>
	</div>
</div>
